(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  if (customElements.get('becay-header')) return;

  /* ---------- Utilidades de color ---------- */
  const lin = (c) => { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
  const relLum = (r, g, b) => 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  const lightness = (Y) => (Y > 0.008856 ? 116 * Math.cbrt(Y) - 16 : 903.3 * Y);

  const colorCtx = (() => {
    const c = document.createElement('canvas');
    c.width = c.height = 1;
    return c.getContext('2d', { willReadFrequently: true });
  })();
  const colorCache = new Map();
  const parseCss = (str) => {
    if (!str || str === 'transparent') return null;
    if (colorCache.has(str)) return colorCache.get(str);
    let out = null;
    try {
      colorCtx.clearRect(0, 0, 1, 1);
      colorCtx.fillStyle = 'rgba(0,0,0,0)';
      colorCtx.fillStyle = str;
      colorCtx.fillRect(0, 0, 1, 1);
      const d = colorCtx.getImageData(0, 0, 1, 1).data;
      if (d[3]) out = { r: d[0], g: d[1], b: d[2], a: d[3] / 255 };
    } catch (e) { out = null; }
    colorCache.set(str, out);
    return out;
  };

  const parsePos = (pos) => {
    const parts = (pos || '50% 50%').trim().split(/\s+/);
    const f = (s) => {
      if (!s) return 0.5;
      if (s.endsWith('%')) return parseFloat(s) / 100;
      if (s === 'left' || s === 'top') return 0;
      if (s === 'right' || s === 'bottom') return 1;
      return 0.5;
    };
    return [f(parts[0]), f(parts[1] || parts[0])];
  };

  const mapPoint = (rect, fit, pos, ar, x, y) => {
    const rw = rect.width, rh = rect.height;
    if (!rw || !rh || !ar) return null;
    let dw, dh;
    if (fit === 'fill') { dw = rw; dh = rh; }
    else if (fit === 'contain' || fit === 'scale-down') {
      if (rw / rh > ar) { dh = rh; dw = rh * ar; } else { dw = rw; dh = rw / ar; }
    } else {
      if (rw / rh > ar) { dw = rw; dh = rw / ar; } else { dh = rh; dw = rh * ar; }
    }
    const p = parsePos(pos);
    const u = (x - rect.left - (rw - dw) * p[0]) / dw;
    const v = (y - rect.top - (rh - dh) * p[1]) / dh;
    if (u < 0 || u > 1 || v < 0 || v > 1) return null;
    return [u, v];
  };

  const pixelAt = (rec, u, v) => {
    const x = Math.min(rec.w - 1, Math.max(0, Math.floor(u * rec.w)));
    const y = Math.min(rec.h - 1, Math.max(0, Math.floor(v * rec.h)));
    let pr = 0, pg = 0, pb = 0, sa = 0, n = 0;
    for (let dy = -1; dy <= 1; dy++) {
      for (let dx = -1; dx <= 1; dx++) {
        const px = Math.min(rec.w - 1, Math.max(0, x + dx));
        const py = Math.min(rec.h - 1, Math.max(0, y + dy));
        const i = (py * rec.w + px) * 4;
        const al = rec.data[i + 3] / 255;
        pr += rec.data[i] * al; pg += rec.data[i + 1] * al; pb += rec.data[i + 2] * al;
        sa += al; n++;
      }
    }
    if (!sa) return { Y: 0, a: 0 };
    return { Y: relLum(pr / sa, pg / sa, pb / sa), a: sa / n };
  };

  const grab = (source, w, h) => {
    const s = 64 / Math.max(w, h);
    const cw = Math.max(1, Math.round(w * s));
    const ch = Math.max(1, Math.round(h * s));
    const c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(source, 0, 0, cw, ch);
    return { data: ctx.getImageData(0, 0, cw, ch).data, w: cw, h: ch, ar: w / h };
  };

  const smallUrl = (u) => {
    try {
      const url = new URL(u, location.href);
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(url.href)) {
        url.searchParams.set('width', '96');
        url.searchParams.delete('height');
        url.searchParams.delete('crop');
      }
      return url.href;
    } catch (e) { return u; }
  };

  /* ---------- Parche ligero de fetch para detectar cambios de carrito ---------- */
  if (!window.__becayFetchPatched && typeof window.fetch === 'function') {
    window.__becayFetchPatched = true;
    const origFetch = window.fetch;
    window.fetch = function (...args) {
      const p = origFetch.apply(this, args);
      try {
        const input = args[0];
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(() => document.dispatchEvent(new CustomEvent('becay:cart-changed'))).catch(() => {});
        }
      } catch (e) { /* noop */ }
      return p;
    };
  }

  class BecayHeader extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      this.cfg = {
        threshold: Number.isFinite(parseFloat(d.scrollThreshold)) ? parseFloat(d.scrollThreshold) : 40,
        pillAlways: d.pillAlways === 'true',
        hideOnScroll: d.hideOnScroll === 'true',
        forceTone: d.forceTone || 'auto',
        mediaFallback: d.mediaFallback === 'light' ? 'light' : 'dark',
        lumThreshold: parseFloat(d.lumThreshold) || 52,
        trigger: d.trigger || 'click',
        closeOnScroll: d.closeOnScroll === 'true',
        cartDrawer: d.cartDrawer === 'true',
        breakpoint: parseFloat(d.breakpoint) || 990
      };

      this.bar = this.querySelector('[data-bar]');
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.activeId = null;
      this.lastY = window.scrollY || 0;
      this.imgCache = new Map();
      this._pass = null;
      this._lastDetect = 0;
      this._toneReady = false;
      this._ticking = false;
      this._hoverTimer = null;
      this._drag = null;
      this._wasMobile = this.isMobile();

      this._onClick = this.onClick.bind(this);
      this._onDocPointer = this.onDocPointer.bind(this);
      this._onKey = this.onKey.bind(this);
      this._onScroll = this.onScroll.bind(this);
      this._onResize = this.onResize.bind(this);
      this._onMedia = () => this.requestDetect();
      this._onCart = () => this.refreshCart();
      this._onMove = this.onDragMove.bind(this);
      this._onUp = this.onDragEnd.bind(this);

      this.addEventListener('click', this._onClick);
      this.addEventListener('change', (e) => {
        if (e.target && e.target.matches && e.target.matches('[data-autosubmit]')) {
          const form = e.target.closest('form');
          if (form) form.submit();
        }
      });
      document.addEventListener('pointerdown', this._onDocPointer);
      document.addEventListener('keydown', this._onKey);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize);
      window.addEventListener('load', this._onMedia);
      document.addEventListener('load', this._onMedia, true);
      document.addEventListener('loadeddata', this._onMedia, true);
      document.addEventListener('becay:cart-changed', this._onCart);
      document.addEventListener('cart:updated', this._onCart);
      document.addEventListener('cart:refresh', this._onCart);
      window.addEventListener('pageshow', this._onCart);
      window.addEventListener('pointermove', this._onMove);
      window.addEventListener('pointerup', this._onUp);
      window.addEventListener('pointercancel', this._onUp);

      try {
        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this._unsub = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
        }
      } catch (e) { /* noop */ }

      this.querySelectorAll('[data-chips]').forEach((el) => {
        el.addEventListener('pointerdown', (e) => this.onDragStart(e, el));
        el.addEventListener('dragstart', (e) => e.preventDefault());
        el.addEventListener('click', (e) => {
          if (el._suppressClick) { e.preventDefault(); e.stopPropagation(); el._suppressClick = false; }
        }, true);
      });

      if (this.cfg.trigger === 'hover') this.bindHover();

      this.refreshState();
      this.detect();
      this._interval = setInterval(() => { if (!document.hidden) this.requestDetect(); }, 600);
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this._onDocPointer);
      document.removeEventListener('keydown', this._onKey);
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('load', this._onMedia);
      document.removeEventListener('load', this._onMedia, true);
      document.removeEventListener('loadeddata', this._onMedia, true);
      document.removeEventListener('becay:cart-changed', this._onCart);
      document.removeEventListener('cart:updated', this._onCart);
      document.removeEventListener('cart:refresh', this._onCart);
      window.removeEventListener('pageshow', this._onCart);
      window.removeEventListener('pointermove', this._onMove);
      window.removeEventListener('pointerup', this._onUp);
      window.removeEventListener('pointercancel', this._onUp);
      clearInterval(this._interval);
      clearTimeout(this._detectTimer);
      clearTimeout(this._hoverTimer);
      if (typeof this._unsub === 'function') this._unsub();
      document.documentElement.style.overflow = '';
    }

    isMobile() { return window.innerWidth < this.cfg.breakpoint; }

    /* ---------- Estado (scroll / ocultar) ---------- */
    onScroll() {
      if (!this._ticking) {
        this._ticking = true;
        requestAnimationFrame(() => { this._ticking = false; this.refreshState(); });
      }
      this.requestDetect();
    }

    refreshState() {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const scrolled = this.cfg.pillAlways || y > this.cfg.threshold || this.activeId !== null;
      this.dataset.scrolled = scrolled ? 'true' : 'false';

      const dy = y - this.lastY;
      if (this.cfg.closeOnScroll && this.activeId && this.activeId !== 'mobile' && Math.abs(dy) > 30) this.closePanels();

      if (this.cfg.hideOnScroll && !this.activeId) {
        if (y > 200 && dy > 6) this.dataset.hidden = 'true';
        else if (dy < -6 || y <= 200) this.dataset.hidden = 'false';
      } else if (this.dataset.hidden === 'true' && this.activeId) {
        this.dataset.hidden = 'false';
      }
      if (Math.abs(dy) > 6 || y <= 200) this.lastY = y;
    }

    onResize() {
      const mobile = this.isMobile();
      if (mobile !== this._wasMobile) { this._wasMobile = mobile; this.closePanels(); }
      this.updateOverflow();
      this.requestDetect();
    }

    /* ---------- Paneles ---------- */
    getPanel(id) { return this.panels.find((p) => p.dataset.panel === id); }
    getTriggers(id) { return Array.from(this.querySelectorAll('[data-panel-trigger]')).filter((t) => t.dataset.panelTrigger === id); }

    toggle(id) { this.activeId === id ? this.closePanels() : this.openPanel(id); }

    openPanel(id) {
      const panel = this.getPanel(id);
      if (!panel) return;
      this.closePanels(false);
      this.activeId = id;
      panel.inert = false;
      panel.classList.add('is-open');
      this.getTriggers(id).forEach((t) => t.setAttribute('aria-expanded', 'true'));
      this.dataset.open = 'true';
      if (id === 'mobile') document.documentElement.style.overflow = 'hidden';
      this.updateOverflow();
      this.refreshState();
      if (id === 'search') {
        const input = panel.querySelector('[data-search-input]');
        if (input) setTimeout(() => input.focus({ preventScroll: true }), 60);
      }
    }

    closePanels(refresh = true) {
      const prev = this.activeId;
      this.panels.forEach((p) => { p.classList.remove('is-open'); p.inert = true; });
      this.querySelectorAll('[data-panel-trigger]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
      this.activeId = null;
      delete this.dataset.open;
      if (prev === 'mobile') document.documentElement.style.overflow = '';
      if (refresh) this.refreshState();
    }

    updateOverflow() {
      this.querySelectorAll('[data-chips]').forEach((el) => {
        if (el.scrollWidth > el.clientWidth + 1) el.setAttribute('data-overflow', '');
        else el.removeAttribute('data-overflow');
      });
    }

    onClick(e) {
      const trigger = e.target.closest('[data-panel-trigger]');
      if (trigger && this.contains(trigger)) {
        e.preventDefault();
        this._lastTrigger = trigger;
        this.toggle(trigger.dataset.panelTrigger);
        return;
      }
      const acc = e.target.closest('[data-accordion]');
      if (acc) {
        const open = acc.getAttribute('aria-expanded') === 'true';
        acc.setAttribute('aria-expanded', open ? 'false' : 'true');
        const target = document.getElementById(acc.getAttribute('aria-controls'));
        if (target) target.hidden = open;
        return;
      }
      const cart = e.target.closest('[data-cart]');
      if (cart && this.cfg.cartDrawer) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          this.closePanels();
          try { drawer.open(cart); } catch (err) { window.location.href = cart.href; }
          return;
        }
      }
      if (e.target.closest('.bc__panel a[href]')) this.closePanels();
    }

    onDocPointer(e) {
      if (this.activeId && !this.contains(e.target)) this.closePanels();
    }

    onKey(e) {
      if (e.key === 'Escape' && this.activeId) {
        this.closePanels();
        if (this._lastTrigger) this._lastTrigger.focus();
      }
    }

    bindHover() {
      const cancel = () => clearTimeout(this._hoverTimer);
      const schedule = () => {
        cancel();
        this._hoverTimer = setTimeout(() => {
          if (this.activeId && this.activeId.indexOf('drop-') === 0) this.closePanels();
        }, 220);
      };
      this.querySelectorAll('[data-panel-trigger^="drop-"]').forEach((t) => {
        t.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse' || this.isMobile()) return;
          cancel();
          if (this.activeId !== t.dataset.panelTrigger) this.openPanel(t.dataset.panelTrigger);
        });
      });
      [this.bar, ...this.panels].forEach((el) => {
        el.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') cancel(); });
        el.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') schedule(); });
      });
    }

    /* ---------- Arrastrar chips con el ratón ---------- */
    onDragStart(e, el) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      this._drag = { el, x: e.clientX, left: el.scrollLeft, moved: false };
    }
    onDragMove(e) {
      const d = this._drag;
      if (!d) return;
      const dx = e.clientX - d.x;
      if (!d.moved && Math.abs(dx) > 5) { d.moved = true; d.el.classList.add('is-dragging'); }
      if (d.moved) d.el.scrollLeft = d.left - dx;
    }
    onDragEnd() {
      const d = this._drag;
      if (!d) return;
      d.el.classList.remove('is-dragging');
      if (d.moved) {
        d.el._suppressClick = true;
        setTimeout(() => { d.el._suppressClick = false; }, 0);
      }
      this._drag = null;
    }

    /* ---------- Carrito ---------- */
    refreshCart() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((r) => r.json())
        .then((cart) => this.setCount(cart.item_count))
        .catch(() => {});
    }
    setCount(n) {
      const el = this.querySelector('[data-cart-count]');
      if (!el) return;
      el.textContent = n;
      const showZero = !el.hasAttribute('hidden') && n === 0 && el.dataset.showZero === 'true';
      el.hidden = n === 0 && !showZero;
      const link = this.querySelector('[data-cart]');
      if (link) link.setAttribute('aria-label', 'Carrito, ' + n + ' artículos');
    }

    /* ---------- Detección de color de fondo ---------- */
    requestDetect() {
      if (this._detectTimer) return;
      const wait = Math.max(0, 70 - (performance.now() - this._lastDetect));
      this._detectTimer = setTimeout(() => {
        this._detectTimer = null;
        this._lastDetect = performance.now();
        this.detect();
      }, wait);
    }

    setTone(tone) {
      if (tone !== 'dark' && tone !== 'light') return;
      if (this.dataset.tone !== tone) {
        this.dataset.tone = tone;
        this.dispatchEvent(new CustomEvent('becay:tone', { bubbles: true, detail: { tone } }));
      }
    }

    detect() {
      if (this.cfg.forceTone !== 'auto') { this.setTone(this.cfg.forceTone); return; }
      if (!this.bar) return;
      const rect = this.bar.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const y = Math.min(window.innerHeight - 1, Math.max(1, rect.top + rect.height / 2));
      this._pass = new Map();
      let sum = 0, n = 0;
      [0.1, 0.3, 0.5, 0.7, 0.9].forEach((f) => {
        let Y = null;
        try { Y = this.lumAt(rect.left + rect.width * f, y); } catch (e) { Y = null; }
        if (Y !== null && Y !== undefined) { sum += Y; n++; }
      });
      this._pass = null;
      if (!n) return;
      const L = lightness(sum / n);
      const t = this.cfg.lumThreshold;
      const cur = this.dataset.tone;
      let next = cur;
      if (!this._toneReady) { next = L > t ? 'light' : 'dark'; this._toneReady = true; }
      else if (cur === 'dark' && L > t + 3) next = 'light';
      else if (cur === 'light' && L < t - 3) next = 'dark';
      this.setTone(next);
    }

    fallbackY() { return this.cfg.mediaFallback === 'light' ? 0.85 : 0.02; }

    pageBgY() {
      const els = [document.body, document.documentElement];
      for (const el of els) {
        if (!el) continue;
        const c = parseCss(getComputedStyle(el).backgroundColor);
        if (c && c.a > 0.5) return relLum(c.r, c.g, c.b);
      }
      return 1;
    }

    lumAt(x, y) {
      const stack = document.elementsFromPoint(x, y);
      let remain = 1, acc = 0;
      const add = (Y, a) => { a = Math.min(1, Math.max(0, a)); acc += remain * a * Y; remain *= (1 - a); };

      for (const el of stack) {
        if (this.contains(el)) continue;
        const ex = el.closest ? el.closest('[data-header-bg]') : null;
        if (ex) return ex.dataset.headerBg === 'light' ? 0.9 : 0.01;

        const cs = getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden') continue;
        let k = parseFloat(cs.opacity);
        if (!Number.isFinite(k)) k = 1;
        if (k === 0) continue;

        const tag = el.tagName;
        if (tag === 'IMG') {
          const s = this.imgSample(el, cs, x, y);
          if (s) add(s.Y, s.a * k);
        } else if (tag === 'VIDEO') {
          const s = this.videoSample(el, cs, x, y);
          if (s) add(s.Y, s.a * k);
        } else if (tag === 'CANVAS') {
          try {
            const rec = grab(el, el.width, el.height);
            const uv = mapPoint(el.getBoundingClientRect(), 'fill', '50% 50%', rec.ar, x, y);
            if (uv) { const p = pixelAt(rec, uv[0], uv[1]); add(p.Y, p.a * k); }
          } catch (e) { add(this.fallbackY(), k); }
        } else {
          const m = /url\((['"]?)(.*?)\1\)/.exec(cs.backgroundImage || '');
          if (m && m[2] && m[2].indexOf('data:') !== 0) {
            const fit = cs.backgroundSize === 'contain' ? 'contain' : (cs.backgroundSize === '100% 100%' ? 'fill' : 'cover');
            const s = this.urlSample(m[2], el.getBoundingClientRect(), fit, cs.backgroundPosition, x, y);
            if (s) add(s.Y, s.a * k);
          }
        }

        const col = parseCss(cs.backgroundColor);
        if (col) add(relLum(col.r, col.g, col.b), col.a * k);
        if (remain < 0.03) break;
      }
      if (remain > 0.03) acc += remain * this.pageBgY();
      return acc;
    }

    imgSample(el, cs, x, y) {
      const src = el.currentSrc || el.src;
      if (!src || !el.complete || !el.naturalWidth) return null;
      return this.urlSample(src, el.getBoundingClientRect(), cs.objectFit || 'fill', cs.objectPosition, x, y);
    }

    urlSample(src, rect, fit, pos, x, y) {
      let rec = this.imgCache.get(src);
      if (rec === undefined) {
        this.imgCache.set(src, 'pending');
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          try { this.imgCache.set(src, grab(img, img.naturalWidth, img.naturalHeight)); }
          catch (e) { this.imgCache.set(src, null); }
          this.requestDetect();
        };
        img.onerror = () => { this.imgCache.set(src, null); this.requestDetect(); };
        img.src = smallUrl(src);
        rec = 'pending';
      }
      if (rec === 'pending' || rec === null) return { Y: this.fallbackY(), a: 1 };
      const uv = mapPoint(rect, fit, pos, rec.ar, x, y);
      if (!uv) return null;
      return pixelAt(rec, uv[0], uv[1]);
    }

    videoSample(el, cs, x, y) {
      const rect = el.getBoundingClientRect();
      if (el.readyState >= 2 && el.videoWidth) {
        let rec = this._pass ? this._pass.get(el) : undefined;
        if (rec === undefined) {
          try { rec = grab(el, el.videoWidth, el.videoHeight); } catch (e) { rec = null; }
          if (this._pass) this._pass.set(el, rec);
        }
        if (rec) {
          const uv = mapPoint(rect, cs.objectFit || 'fill', cs.objectPosition, rec.ar, x, y);
          return uv ? pixelAt(rec, uv[0], uv[1]) : null;
        }
      }
      if (el.poster) return this.urlSample(el.poster, rect, cs.objectFit || 'fill', cs.objectPosition, x, y);
      return { Y: this.fallbackY(), a: 1 };
    }
  }

  customElements.define('becay-header', BecayHeader);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headerfinal"]) return;
  try {
    
(() => {
  if (customElements.get('becay-header')) return;

  /* ---------- Utilidades de color ---------- */
  const lin = (c) => { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
  const relLum = (r, g, b) => 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  const lightness = (Y) => (Y > 0.008856 ? 116 * Math.cbrt(Y) - 16 : 903.3 * Y);

  const colorCtx = (() => {
    const c = document.createElement('canvas');
    c.width = c.height = 1;
    return c.getContext('2d', { willReadFrequently: true });
  })();
  const colorCache = new Map();
  const parseCss = (str) => {
    if (!str || str === 'transparent') return null;
    if (colorCache.has(str)) return colorCache.get(str);
    let out = null;
    try {
      colorCtx.clearRect(0, 0, 1, 1);
      colorCtx.fillStyle = 'rgba(0,0,0,0)';
      colorCtx.fillStyle = str;
      colorCtx.fillRect(0, 0, 1, 1);
      const d = colorCtx.getImageData(0, 0, 1, 1).data;
      if (d[3]) out = { r: d[0], g: d[1], b: d[2], a: d[3] / 255 };
    } catch (e) { out = null; }
    colorCache.set(str, out);
    return out;
  };

  const parsePos = (pos) => {
    const parts = (pos || '50% 50%').trim().split(/\s+/);
    const f = (s) => {
      if (!s) return 0.5;
      if (s.endsWith('%')) return parseFloat(s) / 100;
      if (s === 'left' || s === 'top') return 0;
      if (s === 'right' || s === 'bottom') return 1;
      return 0.5;
    };
    return [f(parts[0]), f(parts[1] || parts[0])];
  };

  const mapPoint = (rect, fit, pos, ar, x, y) => {
    const rw = rect.width, rh = rect.height;
    if (!rw || !rh || !ar) return null;
    let dw, dh;
    if (fit === 'fill') { dw = rw; dh = rh; }
    else if (fit === 'contain' || fit === 'scale-down') {
      if (rw / rh > ar) { dh = rh; dw = rh * ar; } else { dw = rw; dh = rw / ar; }
    } else {
      if (rw / rh > ar) { dw = rw; dh = rw / ar; } else { dh = rh; dw = rh * ar; }
    }
    const p = parsePos(pos);
    const u = (x - rect.left - (rw - dw) * p[0]) / dw;
    const v = (y - rect.top - (rh - dh) * p[1]) / dh;
    if (u < 0 || u > 1 || v < 0 || v > 1) return null;
    return [u, v];
  };

  const pixelAt = (rec, u, v) => {
    const x = Math.min(rec.w - 1, Math.max(0, Math.floor(u * rec.w)));
    const y = Math.min(rec.h - 1, Math.max(0, Math.floor(v * rec.h)));
    let pr = 0, pg = 0, pb = 0, sa = 0, n = 0;
    for (let dy = -1; dy <= 1; dy++) {
      for (let dx = -1; dx <= 1; dx++) {
        const px = Math.min(rec.w - 1, Math.max(0, x + dx));
        const py = Math.min(rec.h - 1, Math.max(0, y + dy));
        const i = (py * rec.w + px) * 4;
        const al = rec.data[i + 3] / 255;
        pr += rec.data[i] * al; pg += rec.data[i + 1] * al; pb += rec.data[i + 2] * al;
        sa += al; n++;
      }
    }
    if (!sa) return { Y: 0, a: 0 };
    return { Y: relLum(pr / sa, pg / sa, pb / sa), a: sa / n };
  };

  const grab = (source, w, h) => {
    const s = 64 / Math.max(w, h);
    const cw = Math.max(1, Math.round(w * s));
    const ch = Math.max(1, Math.round(h * s));
    const c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(source, 0, 0, cw, ch);
    return { data: ctx.getImageData(0, 0, cw, ch).data, w: cw, h: ch, ar: w / h };
  };

  const smallUrl = (u) => {
    try {
      const url = new URL(u, location.href);
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(url.href)) {
        url.searchParams.set('width', '96');
        url.searchParams.delete('height');
        url.searchParams.delete('crop');
      }
      return url.href;
    } catch (e) { return u; }
  };

  /* ---------- Parche ligero de fetch para detectar cambios de carrito ---------- */
  if (!window.__becayFetchPatched && typeof window.fetch === 'function') {
    window.__becayFetchPatched = true;
    const origFetch = window.fetch;
    window.fetch = function (...args) {
      const p = origFetch.apply(this, args);
      try {
        const input = args[0];
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(() => document.dispatchEvent(new CustomEvent('becay:cart-changed'))).catch(() => {});
        }
      } catch (e) { /* noop */ }
      return p;
    };
  }

  class BecayHeader extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      this.cfg = {
        threshold: Number.isFinite(parseFloat(d.scrollThreshold)) ? parseFloat(d.scrollThreshold) : 40,
        pillAlways: d.pillAlways === 'true',
        hideOnScroll: d.hideOnScroll === 'true',
        forceTone: d.forceTone || 'auto',
        mediaFallback: d.mediaFallback === 'light' ? 'light' : 'dark',
        lumThreshold: parseFloat(d.lumThreshold) || 52,
        trigger: d.trigger || 'click',
        closeOnScroll: d.closeOnScroll === 'true',
        cartDrawer: d.cartDrawer === 'true',
        breakpoint: parseFloat(d.breakpoint) || 990
      };

      this.bar = this.querySelector('[data-bar]');
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.activeId = null;
      this.lastY = window.scrollY || 0;
      this.imgCache = new Map();
      this._pass = null;
      this._lastDetect = 0;
      this._toneReady = false;
      this._ticking = false;
      this._hoverTimer = null;
      this._drag = null;
      this._wasMobile = this.isMobile();

      this._onClick = this.onClick.bind(this);
      this._onDocPointer = this.onDocPointer.bind(this);
      this._onKey = this.onKey.bind(this);
      this._onScroll = this.onScroll.bind(this);
      this._onResize = this.onResize.bind(this);
      this._onMedia = () => this.requestDetect();
      this._onCart = () => this.refreshCart();
      this._onMove = this.onDragMove.bind(this);
      this._onUp = this.onDragEnd.bind(this);

      this.addEventListener('click', this._onClick);
      this.addEventListener('change', (e) => {
        if (e.target && e.target.matches && e.target.matches('[data-autosubmit]')) {
          const form = e.target.closest('form');
          if (form) form.submit();
        }
      });
      document.addEventListener('pointerdown', this._onDocPointer);
      document.addEventListener('keydown', this._onKey);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize);
      window.addEventListener('load', this._onMedia);
      document.addEventListener('load', this._onMedia, true);
      document.addEventListener('loadeddata', this._onMedia, true);
      document.addEventListener('becay:cart-changed', this._onCart);
      document.addEventListener('cart:updated', this._onCart);
      document.addEventListener('cart:refresh', this._onCart);
      window.addEventListener('pageshow', this._onCart);
      window.addEventListener('pointermove', this._onMove);
      window.addEventListener('pointerup', this._onUp);
      window.addEventListener('pointercancel', this._onUp);

      try {
        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this._unsub = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
        }
      } catch (e) { /* noop */ }

      this.querySelectorAll('[data-chips]').forEach((el) => {
        el.addEventListener('pointerdown', (e) => this.onDragStart(e, el));
        el.addEventListener('dragstart', (e) => e.preventDefault());
        el.addEventListener('click', (e) => {
          if (el._suppressClick) { e.preventDefault(); e.stopPropagation(); el._suppressClick = false; }
        }, true);
      });

      if (this.cfg.trigger === 'hover') this.bindHover();

      this.refreshState();
      this.detect();
      this._interval = setInterval(() => { if (!document.hidden) this.requestDetect(); }, 600);
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this._onDocPointer);
      document.removeEventListener('keydown', this._onKey);
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('load', this._onMedia);
      document.removeEventListener('load', this._onMedia, true);
      document.removeEventListener('loadeddata', this._onMedia, true);
      document.removeEventListener('becay:cart-changed', this._onCart);
      document.removeEventListener('cart:updated', this._onCart);
      document.removeEventListener('cart:refresh', this._onCart);
      window.removeEventListener('pageshow', this._onCart);
      window.removeEventListener('pointermove', this._onMove);
      window.removeEventListener('pointerup', this._onUp);
      window.removeEventListener('pointercancel', this._onUp);
      clearInterval(this._interval);
      clearTimeout(this._detectTimer);
      clearTimeout(this._hoverTimer);
      if (typeof this._unsub === 'function') this._unsub();
      document.documentElement.style.overflow = '';
    }

    isMobile() { return window.innerWidth < this.cfg.breakpoint; }

    /* ---------- Estado (scroll / ocultar) ---------- */
    onScroll() {
      if (!this._ticking) {
        this._ticking = true;
        requestAnimationFrame(() => { this._ticking = false; this.refreshState(); });
      }
      this.requestDetect();
    }

    refreshState() {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const scrolled = this.cfg.pillAlways || y > this.cfg.threshold || this.activeId !== null;
      this.dataset.scrolled = scrolled ? 'true' : 'false';

      const dy = y - this.lastY;
      if (this.cfg.closeOnScroll && this.activeId && this.activeId !== 'mobile' && Math.abs(dy) > 30) this.closePanels();

      if (this.cfg.hideOnScroll && !this.activeId) {
        if (y > 200 && dy > 6) this.dataset.hidden = 'true';
        else if (dy < -6 || y <= 200) this.dataset.hidden = 'false';
      } else if (this.dataset.hidden === 'true' && this.activeId) {
        this.dataset.hidden = 'false';
      }
      if (Math.abs(dy) > 6 || y <= 200) this.lastY = y;
    }

    onResize() {
      const mobile = this.isMobile();
      if (mobile !== this._wasMobile) { this._wasMobile = mobile; this.closePanels(); }
      this.updateOverflow();
      this.requestDetect();
    }

    /* ---------- Paneles ---------- */
    getPanel(id) { return this.panels.find((p) => p.dataset.panel === id); }
    getTriggers(id) { return Array.from(this.querySelectorAll('[data-panel-trigger]')).filter((t) => t.dataset.panelTrigger === id); }

    toggle(id) { this.activeId === id ? this.closePanels() : this.openPanel(id); }

    openPanel(id) {
      const panel = this.getPanel(id);
      if (!panel) return;
      this.closePanels(false);
      this.activeId = id;
      panel.inert = false;
      panel.classList.add('is-open');
      this.getTriggers(id).forEach((t) => t.setAttribute('aria-expanded', 'true'));
      this.dataset.open = 'true';
      if (id === 'mobile') document.documentElement.style.overflow = 'hidden';
      this.updateOverflow();
      this.refreshState();
      if (id === 'search') {
        const input = panel.querySelector('[data-search-input]');
        if (input) setTimeout(() => input.focus({ preventScroll: true }), 60);
      }
    }

    closePanels(refresh = true) {
      const prev = this.activeId;
      this.panels.forEach((p) => { p.classList.remove('is-open'); p.inert = true; });
      this.querySelectorAll('[data-panel-trigger]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
      this.activeId = null;
      delete this.dataset.open;
      if (prev === 'mobile') document.documentElement.style.overflow = '';
      if (refresh) this.refreshState();
    }

    updateOverflow() {
      this.querySelectorAll('[data-chips]').forEach((el) => {
        if (el.scrollWidth > el.clientWidth + 1) el.setAttribute('data-overflow', '');
        else el.removeAttribute('data-overflow');
      });
    }

    onClick(e) {
      const trigger = e.target.closest('[data-panel-trigger]');
      if (trigger && this.contains(trigger)) {
        e.preventDefault();
        this._lastTrigger = trigger;
        this.toggle(trigger.dataset.panelTrigger);
        return;
      }
      const acc = e.target.closest('[data-accordion]');
      if (acc) {
        const open = acc.getAttribute('aria-expanded') === 'true';
        acc.setAttribute('aria-expanded', open ? 'false' : 'true');
        const target = document.getElementById(acc.getAttribute('aria-controls'));
        if (target) target.hidden = open;
        return;
      }
      const cart = e.target.closest('[data-cart]');
      if (cart && this.cfg.cartDrawer) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          this.closePanels();
          try { drawer.open(cart); } catch (err) { window.location.href = cart.href; }
          return;
        }
      }
      if (e.target.closest('.bc__panel a[href]')) this.closePanels();
    }

    onDocPointer(e) {
      if (this.activeId && !this.contains(e.target)) this.closePanels();
    }

    onKey(e) {
      if (e.key === 'Escape' && this.activeId) {
        this.closePanels();
        if (this._lastTrigger) this._lastTrigger.focus();
      }
    }

    bindHover() {
      const cancel = () => clearTimeout(this._hoverTimer);
      const schedule = () => {
        cancel();
        this._hoverTimer = setTimeout(() => {
          if (this.activeId && this.activeId.indexOf('drop-') === 0) this.closePanels();
        }, 220);
      };
      this.querySelectorAll('[data-panel-trigger^="drop-"]').forEach((t) => {
        t.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse' || this.isMobile()) return;
          cancel();
          if (this.activeId !== t.dataset.panelTrigger) this.openPanel(t.dataset.panelTrigger);
        });
      });
      [this.bar, ...this.panels].forEach((el) => {
        el.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') cancel(); });
        el.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') schedule(); });
      });
    }

    /* ---------- Arrastrar chips con el ratón ---------- */
    onDragStart(e, el) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      this._drag = { el, x: e.clientX, left: el.scrollLeft, moved: false };
    }
    onDragMove(e) {
      const d = this._drag;
      if (!d) return;
      const dx = e.clientX - d.x;
      if (!d.moved && Math.abs(dx) > 5) { d.moved = true; d.el.classList.add('is-dragging'); }
      if (d.moved) d.el.scrollLeft = d.left - dx;
    }
    onDragEnd() {
      const d = this._drag;
      if (!d) return;
      d.el.classList.remove('is-dragging');
      if (d.moved) {
        d.el._suppressClick = true;
        setTimeout(() => { d.el._suppressClick = false; }, 0);
      }
      this._drag = null;
    }

    /* ---------- Carrito ---------- */
    refreshCart() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((r) => r.json())
        .then((cart) => this.setCount(cart.item_count))
        .catch(() => {});
    }
    setCount(n) {
      const el = this.querySelector('[data-cart-count]');
      if (!el) return;
      el.textContent = n;
      const showZero = !el.hasAttribute('hidden') && n === 0 && el.dataset.showZero === 'true';
      el.hidden = n === 0 && !showZero;
      const link = this.querySelector('[data-cart]');
      if (link) link.setAttribute('aria-label', 'Carrito, ' + n + ' artículos');
    }

    /* ---------- Detección de color de fondo ---------- */
    requestDetect() {
      if (this._detectTimer) return;
      const wait = Math.max(0, 70 - (performance.now() - this._lastDetect));
      this._detectTimer = setTimeout(() => {
        this._detectTimer = null;
        this._lastDetect = performance.now();
        this.detect();
      }, wait);
    }

    setTone(tone) {
      if (tone !== 'dark' && tone !== 'light') return;
      if (this.dataset.tone !== tone) {
        this.dataset.tone = tone;
        this.dispatchEvent(new CustomEvent('becay:tone', { bubbles: true, detail: { tone } }));
      }
    }

    detect() {
      if (this.cfg.forceTone !== 'auto') { this.setTone(this.cfg.forceTone); return; }
      if (!this.bar) return;
      const rect = this.bar.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const y = Math.min(window.innerHeight - 1, Math.max(1, rect.top + rect.height / 2));
      this._pass = new Map();
      let sum = 0, n = 0;
      [0.1, 0.3, 0.5, 0.7, 0.9].forEach((f) => {
        let Y = null;
        try { Y = this.lumAt(rect.left + rect.width * f, y); } catch (e) { Y = null; }
        if (Y !== null && Y !== undefined) { sum += Y; n++; }
      });
      this._pass = null;
      if (!n) return;
      const L = lightness(sum / n);
      const t = this.cfg.lumThreshold;
      const cur = this.dataset.tone;
      let next = cur;
      if (!this._toneReady) { next = L > t ? 'light' : 'dark'; this._toneReady = true; }
      else if (cur === 'dark' && L > t + 3) next = 'light';
      else if (cur === 'light' && L < t - 3) next = 'dark';
      this.setTone(next);
    }

    fallbackY() { return this.cfg.mediaFallback === 'light' ? 0.85 : 0.02; }

    pageBgY() {
      const els = [document.body, document.documentElement];
      for (const el of els) {
        if (!el) continue;
        const c = parseCss(getComputedStyle(el).backgroundColor);
        if (c && c.a > 0.5) return relLum(c.r, c.g, c.b);
      }
      return 1;
    }

    lumAt(x, y) {
      const stack = document.elementsFromPoint(x, y);
      let remain = 1, acc = 0;
      const add = (Y, a) => { a = Math.min(1, Math.max(0, a)); acc += remain * a * Y; remain *= (1 - a); };

      for (const el of stack) {
        if (this.contains(el)) continue;
        const ex = el.closest ? el.closest('[data-header-bg]') : null;
        if (ex) return ex.dataset.headerBg === 'light' ? 0.9 : 0.01;

        const cs = getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden') continue;
        let k = parseFloat(cs.opacity);
        if (!Number.isFinite(k)) k = 1;
        if (k === 0) continue;

        const tag = el.tagName;
        if (tag === 'IMG') {
          const s = this.imgSample(el, cs, x, y);
          if (s) add(s.Y, s.a * k);
        } else if (tag === 'VIDEO') {
          const s = this.videoSample(el, cs, x, y);
          if (s) add(s.Y, s.a * k);
        } else if (tag === 'CANVAS') {
          try {
            const rec = grab(el, el.width, el.height);
            const uv = mapPoint(el.getBoundingClientRect(), 'fill', '50% 50%', rec.ar, x, y);
            if (uv) { const p = pixelAt(rec, uv[0], uv[1]); add(p.Y, p.a * k); }
          } catch (e) { add(this.fallbackY(), k); }
        } else {
          const m = /url\((['"]?)(.*?)\1\)/.exec(cs.backgroundImage || '');
          if (m && m[2] && m[2].indexOf('data:') !== 0) {
            const fit = cs.backgroundSize === 'contain' ? 'contain' : (cs.backgroundSize === '100% 100%' ? 'fill' : 'cover');
            const s = this.urlSample(m[2], el.getBoundingClientRect(), fit, cs.backgroundPosition, x, y);
            if (s) add(s.Y, s.a * k);
          }
        }

        const col = parseCss(cs.backgroundColor);
        if (col) add(relLum(col.r, col.g, col.b), col.a * k);
        if (remain < 0.03) break;
      }
      if (remain > 0.03) acc += remain * this.pageBgY();
      return acc;
    }

    imgSample(el, cs, x, y) {
      const src = el.currentSrc || el.src;
      if (!src || !el.complete || !el.naturalWidth) return null;
      return this.urlSample(src, el.getBoundingClientRect(), cs.objectFit || 'fill', cs.objectPosition, x, y);
    }

    urlSample(src, rect, fit, pos, x, y) {
      let rec = this.imgCache.get(src);
      if (rec === undefined) {
        this.imgCache.set(src, 'pending');
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          try { this.imgCache.set(src, grab(img, img.naturalWidth, img.naturalHeight)); }
          catch (e) { this.imgCache.set(src, null); }
          this.requestDetect();
        };
        img.onerror = () => { this.imgCache.set(src, null); this.requestDetect(); };
        img.src = smallUrl(src);
        rec = 'pending';
      }
      if (rec === 'pending' || rec === null) return { Y: this.fallbackY(), a: 1 };
      const uv = mapPoint(rect, fit, pos, rec.ar, x, y);
      if (!uv) return null;
      return pixelAt(rec, uv[0], uv[1]);
    }

    videoSample(el, cs, x, y) {
      const rect = el.getBoundingClientRect();
      if (el.readyState >= 2 && el.videoWidth) {
        let rec = this._pass ? this._pass.get(el) : undefined;
        if (rec === undefined) {
          try { rec = grab(el, el.videoWidth, el.videoHeight); } catch (e) { rec = null; }
          if (this._pass) this._pass.set(el, rec);
        }
        if (rec) {
          const uv = mapPoint(rect, cs.objectFit || 'fill', cs.objectPosition, rec.ar, x, y);
          return uv ? pixelAt(rec, uv[0], uv[1]) : null;
        }
      }
      if (el.poster) return this.urlSample(el.poster, rect, cs.objectFit || 'fill', cs.objectPosition, x, y);
      return { Y: this.fallbackY(), a: 1 };
    }
  }

  customElements.define('becay-header', BecayHeader);
})();

  } catch(e) { console.error(e); }
})();
})();
